<template>
  <div class="allow-scroll" :class="$style.wrapper">
    <MobilePortraitDummy />
    <Points :numberOfPoints="score" :position="pointsPosition"/>
    <component
      :is="currentTaskView"
      :score="score"
      @completed="() => { currentTask += 1 }"
      @success="saveData({})"
      @stop="stopTimer"
      @updateScore="(value) => { score += value }"
    ></component>
  </div>
</template>

<script>
import Points from '@/components/Points/Points'
import MobilePortraitDummy from '@/components/MobilePortraitDummy/MobilePortraitDummy'

import saveDataMixin from '@/mixins/saveData'

// max 100
export default {
  components: { Points, MobilePortraitDummy },
  mixins: [saveDataMixin],
  data() {
    return {
      score: 0,
      pointsPosition: 'left',
      currentTask: 0,
    }
  },
  created() {
    this.startTimer()
  },
  computed: {
    currentTaskView() {
      switch (this.currentTask) {
        case 0:
          return () => import('./components/task1/task1')
        case 1:
          return () => import('./components/task2/task2')
        case 2:
          return () => import('./components/task3')
        case 3:
          return () => import('./components/task4/task4')
        default:
          return () => import('./components/task1/task1')
      }
    },
  },
}
</script>
<style lang="scss" module>
.wrapper{
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url("~@/assets/lesson3/bg.svg");
  background-color: $lesson3bg;
  background-repeat: repeat-y;
  background-size: cover;

  @media #{$m-mobile} {
    //min-height: 100vh;
    overflow: auto;
    -webkit-overflow-scroll: touch;
  }
}
</style>
